// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var MatchingStatusUpdater = require("./MatchingStatusUpdater.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var RenewBuyerNeedMutation_graphql = require("../../../__generated__/RenewBuyerNeedMutation_graphql.bs.js");

var convertVariables = RenewBuyerNeedMutation_graphql.Internal.convertVariables;

var convertResponse = RenewBuyerNeedMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = RenewBuyerNeedMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, RenewBuyerNeedMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, RenewBuyerNeedMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function use$1(buyerNeedNodeId, handleRenewingError, updateMatchingStatus) {
  var match = use();
  var mutate = match[0];
  var environment = RescriptRelay.useEnvironmentFromContext();
  var fire = function () {
    return mutate({
                nodeId: buyerNeedNodeId
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var renewBuyerNeed = param.renewBuyerNeed;
                  if (renewBuyerNeed !== undefined && renewBuyerNeed.__typename === "BuyerNeedRenewed") {
                    if (updateMatchingStatus) {
                      var extra = "IN_PROGRESS";
                      return MatchingStatusUpdater.update(environment, buyerNeedNodeId, "BuyerNeedV5", extra);
                    } else {
                      return ;
                    }
                  } else {
                    return handleRenewingError();
                  }
                }), (function (param) {
                  handleRenewingError();
                }), undefined);
  };
  return [
          fire,
          match[1]
        ];
}

exports.Mutation = Mutation;
exports.use = use$1;
/* commitMutation Not a pure module */
